import { useEffect, useState } from 'react';

import getQueryParam from '../utils/getQueryParam';

function useTarget(initialState: string): string {
  const [target, setTarget] = useState(initialState);

  useEffect(() => {
    const encodedTarget = encodeURIComponent(getQueryParam('target') || window.location.href);
    setTarget(encodedTarget);
  }, []);

  return target;
}

export default useTarget;
